module.exports = __webpack_public_path__ + "img/ic_twotone_location@2x.be657452.png";